import { jsonSchema } from 'ai';
import { toLlmJsonSchema } from '../../../utils/zodJsonSchema';
export const createAgentInputSchema = (inputSchema) => jsonSchema(
// Zod 4 targets draft-07, so exclusiveMinimum is always numeric here.
toLlmJsonSchema(inputSchema, { reused: 'ref' }), {
    validate: (value) => {
        const result = inputSchema.safeParse(value);
        if (result.success) {
            return { success: true, value: result.data };
        }
        return { success: false, error: result.error };
    },
});
//# sourceMappingURL=agentInputSchema.js.map